export type DirectorStatus = 'Hoạt động' | 'Ngừng hoạt động';
export type MemberPackageStatus = 'Hoạt động' | 'Ngừng hoạt động' | 'Hết thời gian ĐT' | 'Chuyển giao' | 'N/A';
export type ActiveTab = 'member' | 'investment' | 'transactions' | 'commission' | 'contracts';

export interface Director {
    id: string;
    name: string;
    initials: string;
    date: string;
    revenue: string;
    members: number;
    status: DirectorStatus;
    email: string;
    phone: string;
    gender: string;
    birthday: string;
    occupation: string;
    referralCode: string;
}

export interface Transaction {
    id: string;
    time: string;
    type: string;
    amount: string;
    status: string;
}

export interface MemberPackage {
    name: string;
    qty: number;
    assignee: string;
    transferDate: string;
    totalInvestment: string;
    isMine: boolean;
    status: MemberPackageStatus;
    isTransferred: boolean;
    startDate: string;
    duration: number;
}

export interface Member {
    name: string;
    idLabel: string;
    email: string;
    phone: string;
    status: string;
    packages: MemberPackage[];
    total: string;
}

export interface PackageProgress {
    elapsed: number;
    remaining: number;
    duration: number;
    isExpired: boolean;
}


export function getPackageProgress(startDateStr: string, durationMonths: number): PackageProgress | null {
    if (!startDateStr || !durationMonths) {
        return null;
    }

    const start = new Date(startDateStr);
    const now = new Date('2026-05-27');
    let elapsedMonths = (now.getFullYear() - start.getFullYear()) * 12 + (now.getMonth() - start.getMonth());

    if (now.getDate() < start.getDate()) {
        elapsedMonths -= 1;
    }

    const elapsed = Math.max(0, elapsedMonths);
    const isExpired = elapsed >= durationMonths;
    const boundedElapsed = Math.min(elapsed, durationMonths);
    const remaining = Math.max(0, durationMonths - boundedElapsed);

    return { elapsed: boundedElapsed, remaining, duration: durationMonths, isExpired };
}